
import { Link, useParams } from "react-router-dom"
import { Col, Container, Row } from "react-bootstrap"
import Header from "../../components/Header"
import useFetch from "../features/get"
import { useState } from "react"
import { Helmet } from "react-helmet"

function Images(){

    const hotelParams= useParams()
    
    const slug= hotelParams.slug
    const {data, loading, error}= useFetch(`https://api.komorotel.com/api/hotels/slug/${slug}`)
    
    const [openDestination, setOpenDestination]= useState(false)

 

    

    return(
        <>
        <Helmet>
            <title>{data?.name ? `${data.name} - Komorotel` : "Komorotel - Réservez votre séjour"}</title>

            {data?.desc && (
                <meta name="description" content={data.desc} />
            )}

            {data?.name && (
                <meta property="og:title" content={data.name} />
            )}

            {data?.desc && (
                <meta property="og:description" content={data.desc} />
            )}

            {data?.photos?.[0] && (
                <meta property="og:image" content={data.photos[0]} />
            )}
        </Helmet>
        <div onClick={()=> setOpenDestination(false)}>
        <Header openDestination={openDestination} setOpenDestination={setOpenDestination}/>

            {loading ? <div></div> :
            <div className="pt-7">
                <div className="d-flex ms-3 mb-4"><Link to={`/hotel/slug/${slug}`}><button  type="button" className="btn-close me-3" aria-label="Close"></button></Link><p className="fw-bold">{data?.name}</p></div>
                <Container>
                <Row>

                    {data?.photos.map((image, index) => (
                        
                            <Col sm={6} className="mb-5">
                                <img src={image} alt="" height="400px" width="100%" className="rounded shadow-sm object-fit-cover " />
                            </Col>

                    
                    ))}
                    </Row>

                </Container>
                
            </div>}
            </div>
            </>
    )
}
export default Images
